var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1364_1475",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.518555,
    y: 0.199219,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1364_1475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.51855 19.1992H6.61655L17.3148 8.50122L16.2166 7.40297L5.51855 18.1012V19.1992ZM4.51855 20.1992V17.68L17.6993 4.48572C17.8018 4.39439 17.9149 4.3238 18.0386 4.27397C18.1624 4.22414 18.2915 4.19922 18.4258 4.19922C18.5601 4.19922 18.6903 4.22038 18.8163 4.26272C18.9421 4.30505 19.0583 4.3813 19.1648 4.49147L20.2321 5.56472C20.3422 5.67105 20.4176 5.78772 20.4581 5.91472C20.4984 6.04189 20.5186 6.16897 20.5186 6.29597C20.5186 6.43147 20.4957 6.56114 20.4501 6.68497C20.4044 6.80864 20.3317 6.92172 20.2321 7.02422L7.0378 20.1992H4.51855ZM16.7561 7.96172L16.2166 7.40297L17.3148 8.50122L16.7561 7.96172Z",
    fill: "#B2B2B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/write.53f351c4d519c28ef375c67c55653b0b.svg";
export { ForwardRef as ReactComponent };